module.exports = __webpack_public_path__ + "static/img/85093B_1_2_C_20210228_fit.83b4be1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/85093B_1_2_C_20210228_fit.png
// module id = bUwh
// module chunks = 0